export enum STAGES {
  DEVELOPMENT = "DEVELOPMENT",
  ALPHA = "alpha",
  BETA = "beta",
  GAMMA = 'gamma',
  PROD = "prod",
}

export const APPLICATION_NAME = "UI"
